import React, { useContext } from "react";
import { observer } from "mobx-react";
import classnames from "classnames";
import { SportOffer } from "@gp/offer";
import { EventOffer } from "@gp/offer";
import { EventContext, SportOfferContext } from "@gp/components";
import { useOfferColumnResult } from "@state/hooks/offer/useOfferColumnResult";

import { GameScore, CurrentServer } from ".";

export const OfferColumnResult = observer(function OfferColumnResult() {
	const event = useContext(EventContext);
	const sport = useContext(SportOfferContext);
	const columResults = useOfferColumnResult(
		event as EventOffer,
		sport as SportOffer
	);

	if (columResults.lastPeriodScore == null) {
		return (
			<div className="offer__body__data offer__score is-empty">
				&nbsp;
			</div>
		);
	}

	const offerColumnResultClassNames = classnames(
		"offer__body__data offer__score",
		{
			"server-only":
				columResults.gameScore == null &&
				(columResults.serve === "home" ||
					columResults.serve === "away"),
			"set-only":
				columResults.gameScore == null &&
				// @ts-expect-error
				(columResults.serve == null || columResults.serve === ""),
		}
	);

	return (
		<div className={offerColumnResultClassNames}>
			<CurrentServer serve={columResults.serve} />
			<GameScore gameScore={columResults.gameScore} />
			<div className="offer__score__col offer__score__set">
				<div className="offer__score__item">
					{columResults.lastPeriodScore.home || 0}
				</div>
				<div className="offer__score__item">
					{columResults.lastPeriodScore.away || 0}
				</div>
			</div>
		</div>
	);
});
